<template>


  <h3><img src="../../public/favicon.jpg" /> Solar Share</h3>
  Solar Share is a way for users of the Enphase system to easily share and see other solar producers.  By joining Solar Share you agree to share your solar information with other users.

  <br />
  Sharing is done through the Enphase system.  You must have a registered Enphase system to share solar information.  Sharing is done by enabling the built in sharing feature available within Enphase.  Solar Share uses that information to share details.
  <br/>
  All information comes from Enphase, you do not need to send any information manually.  You can disable sharing at any time from within the Solar Share system or from the Enphase system.
  <br/>
  <br/>
  <strong>What information is shared?</strong>
  All information comes from the Enphase system.  When you enable sharing in Enphase it makes your production (not consumption) information available.   Also included is your general location (city/state) and the number of micro inverters you have.  This gives a general sense of the size of your system

  <div class="row mt-2">
    <div class="col-md-4">
      <img class="img-fluid" :src="`${publicPath}img/AllLocations.png`" />
      <p class="text-center">
        View the last 7 days of production from multiple locations
      </p>
    </div>
    <div class="col-md-4">
      <img class="img-fluid" :src="`${publicPath}img/SingleDay.png`" />
      <p class="text-center">
        View the 15 minute production per day
      </p>
    </div>
    <div class="col-md-4">
      <img class="img-fluid" :src="`${publicPath}img/SingleHouse.png`" />
      <p class="text-center">
        View the production of a single location per day
      </p>
    </div>

  </div>

  <div class="row">
    
      <div class="card col-md-6" v-if="mode == 'Login'">
        <div class="card-body">
          <h2 class="card-title">Login</h2>
          <div class="input-group mb-3">            
            <span class="input-group-text">Email&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <input type="text" class="form-control" v-model="email" />
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">Password</span>
            <input type="password" class="form-control" v-model="password" @keydown.enter="handleLogin" />
          </div>
          <button class="btn btn-primary" @click="handleLogin">Login</button>
          &nbsp;
          <!--
          <button class="btn btn-info" @click="mode = 'Register'">Create Account</button>
          -->
        </div>
      </div>
    
<!--
        <div class="card col-md-6" v-if="mode == 'Register'">
          <div class="card-body">
            <h2 class="card-title">Register</h2>
            <div class="input-group mb-3">
              <span class="input-group-text">Full Name&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input type="text" class="form-control" v-model="newUser.fullName" />
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text">Email&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input type="text" class="form-control" v-model="newUser.email" />
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text">Password&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input type="password" class="form-control" v-model="newUser.password"  />
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text">Verify Password</span>
              <input type="password" class="form-control" v-model="newUser.verifyPassword"  />
            </div>
            <button class="btn btn-primary" @click="registerUser" :disabled="newUser.email == '' || newUser.password == '' || (newUser.password != newUser.verifyPassword)">Register</button>
            &nbsp;
            <button class="btn btn-info" @click="mode = 'Login'">I have an account</button>
          </div>
        </div>
      -->
    
  </div>

  <div class="row mt-2">
    <p>
      <strong>Privacy Policy:&nbsp;</strong>Solar Share does not share any information stored or retrieved with any third party service.  Information stored within Solar Share is available to all users of Solar Share.  You may remove yourself from Solar Share at any time and you can disable sharing from within Enphase at any time.  
      Solar Share stores the following information:
      <ul>
        <li>Enphase public share identifier for a solar location</li>
        <li>The general location of the solar location (city and state)</li>
        <li>GPS coordinates of that general location</li>
        <li>The number of micro-inverters at the solar location to give an estimate of size</li>
      </ul>
    </p>
    <p>
      For questions or comments please contact <a href="mailto:support@jwerfel.com?subject=Solar%20Share">support@jwerfel.com</a>
    </p>
  </div>

  

  
</template>

<script>
import pb from '../api';
import { store } from '../store';
import { useToast } from 'vue-toastification';

export default {
  name: 'UserLogin',
  data() {
    return {
      email: '',
      password: '',
      newUser: {
        email : '',
        password: '',
        verifyPassword: '',
        fullName: ''
      },
      mode: 'Login',
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    async registerUser() {
      let toast = useToast();
      try {
        store.isLoading = true;
        const data = {
          "password": this.newUser.password,
          "passwordConfirm": this.newUser.verifyPassword,
          "email": this.newUser.email,
          "emailVisibility": true,
          "verified": false,
          "name": this.newUser.fullName
        };

        await pb.collection('users').create(data);
        toast.info("Your account has been created");
        await pb.collection('users').authWithPassword(this.newUser.email, this.newUser.password);
        this.$emit('login');
      }
      catch(err) {
        console.log("Error: " + JSON.stringify(err));

        for(const key in err.response.data) {
          toast.error(`Error: ${key} ${err.response.data[key].message}`);
        }


        //toast.error("Failed to create user account");
        //toast.error(err.response.message);
      }
      finally {
        store.isLoading = false;
      }
    },
    async handleLogin() {
      try {
        await pb.collection('users').authWithPassword(this.email, this.password);
        this.$emit('login');
      } catch (error) {
        alert('Login failed!');
        console.error(error);
      }
    }
  }
};
</script>

<style>
.card {
  /*max-width: 400px; 
  */
  margin: 0 auto;
  
}
</style>